import React, { useMemo } from 'react';
import styles from './TabLayout.module.scss';
import IconAllUnits from 'src/assets/icons/cap.svg?react';
import IconStudyMode from 'src/assets/icons/book.svg?react';
import IconEditMode from 'src/assets/icons/hepencil.svg?react';
import { ModeTypeEnum } from '@types';
import { useMediaQuery } from 'react-responsive';

type Props = {
  studyMode: string;
  topPos: number;
  handleSelectPlanMode: (studyMode: ModeTypeEnum) => void;
};

const getIconByType = (type: ModeTypeEnum) => {
  switch (type) {
    case 'Create Study Plans':
      return IconEditMode;
    case 'Study Mode':
      return IconStudyMode;
    default: {
      return IconAllUnits;
    }
  }
}

function TabLayout(props: Props) {
  const { studyMode, topPos, handleSelectPlanMode } = props;
  const middleWidth = useMediaQuery({maxWidth: 1330});
  const smallWidth = useMediaQuery({maxWidth: 1024});

  const isTablet = useMemo(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    return /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent)
  }, []);

  const _filtered = useMemo(() => {
    return (Object.keys(ModeTypeEnum) as (keyof typeof ModeTypeEnum)[]).map((key) => {
        return ModeTypeEnum[key];
      },
    );
  }, []);

  var height = middleWidth ? smallWidth ? 120 : 160 : 203;
  const leftScrollView = document.getElementById("navMenuBar")
  if (leftScrollView) {
    const rect = leftScrollView.getBoundingClientRect();
    if (topPos >= 88) {
      height = middleWidth ? smallWidth ? 120 : 160 : 203;
    } else if (rect.height - (87 - topPos) < 90) {
      height = 90;
    } else {
      height = rect.height - (87 - topPos);
    }
  }
  return (
    <div id={"navMenuBar"} className={`${studyMode === ModeTypeEnum.Study ? styles.studyModeNavView : styles.navView} ${isTablet ? '' : topPos < 88 ? styles.studyModeHeadStickyView : styles.headStickyView}`} style={{height: `${height}px`}}>
      {_filtered.map((item, index) => {
        const Icon = getIconByType(item as ModeTypeEnum);
        return (
          <div key={index} className={styles.itemWrapper} onClick={() => handleSelectPlanMode(item)}>
            <div className={[styles.listItem, (studyMode === item && height > 100) ? styles.selItem : ''].join(' ')}>
              <Icon className={[styles.icon, studyMode === item ? styles.selIcon : ''].join(' ')}/>
              <div className={[styles.listTitle, studyMode === item ? styles.selItemTitle : ''].join(' ')}>
                {item}
              </div>
            </div>
          </div>
        )
      })}
    </div>
  );
}

export default TabLayout;
